import { ChangeDetectionStrategy, ChangeDetectorRef, Component,ViewEncapsulation, OnInit, Inject, PLATFORM_ID, inject } from '@angular/core';
import {  ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, mergeMap} from 'rxjs/operators';
import { EventService } from '../../../services/event.service';
import { UserService } from '../../../services/user.service';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'wire-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, CommonModule],
})
export class HeaderComponent implements OnInit {
  public closeDisplayed = false;
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly eventService = inject(EventService);
  public readonly userService = inject(UserService);
  public currentEvent = this.eventService.currentEvent;
  public currentUser = this.userService.currentUser;

  constructor(
    private readonly router: Router,
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    private readonly cdr: ChangeDetectorRef
  ) {}

  getDateRange(startDate: Date, endDate: Date): string {
    const start = new Date(startDate);
    const month = start.toLocaleDateString('en-US', { month: 'long' }).toUpperCase();
    const year = start.getFullYear();
    return `${month} ${year}`;
  }

  ngOnInit() {

    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      mergeMap(route => route.data)
    ).subscribe(data => {
      this.closeDisplayed = data['headerClose'] ?? false;
      this.cdr.detectChanges();
    });
  }
}




